<template>
  <RangePicker
    :title="$t('calculators_common.number_of_games')"
    :description="$t('calculators_common.select_number_of_games')"
    type="games-other"
  />
  <RangePicker
    :title="$t('calculators_common.number_of_booster')"
    :description="$t('calculators_common.select_number_of_booster')"
    :type="'boosters'"
    :max="5"
  />
  <ExtraOptionPicker :options="['tier', 'server']" />
  <OptionPicker />
</template>

<script setup>
import RangePicker from "../commonpickers/RangePicker.vue";
import OptionPicker from "./pickers/OptionPicker.vue";
import ExtraOptionPicker from "./pickers/ExtraOptionPicker.vue";
import { onMounted, watch } from "vue";
const {
  setDetails,
  setPlatform,
  setServer,
  setGameAndPack,
  clearCheckout,
  setTier,
  setCalculating,
} = useCheckoutStore();

const { getGame, getGamePack } = useGameStore();
const handleDetails = () => {
  clearCheckout();

  setDetails({
    numberOfGames: 1,
    numberOfBoosters: 1,
  });

  setPlatform({
    platform: 1,
  });
  setTier(1);
  setServer(1);
  setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });
};

handleDetails();

onNuxtReady(() => {
  setCalculating();
});
watch(
  () => getGamePack,
  (newVal) => {
    setGameAndPack({
      game: getGame.id,
      pack: newVal.id,
      fullGame: getGame,
      fullPack: newVal,
    });
  }
);
</script>
